import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./textos_legales.css";
import { FiArrowLeft } from "react-icons/fi"; // Icono de "volver atrás"

function Cookies() {
    const nombre_cliente = "Federación de Balonmano de Castilla-La Mancha (en adelante, “FBMCLM”)"; // Variable para automatizar el nombre del cliente

    const cookiesData = [
        {
            nombre: "CookiesAccepted",
            tipo: "Técnica",
            origen: "Propia",
            proposito:
                "Esta cookie se emplea para registrar la aceptación del usuario sobre el uso de cookies en el sitio web. Su objetivo es evitar que el banner de consentimiento vuelva a aparecer en cada visita.",
            datos: "Solo almacena el valor 'true' o 'false', indicando si el usuario ha aceptado o no las cookies.",
            caducidad: "1 año",
        },
        {
            nombre: "SecurityToken",
            tipo: "Técnica",
            origen: "Propia",
            proposito:
                "Esta cookie se utiliza para mejorar la seguridad del sitio web, previniendo ataques como la falsificación de solicitudes entre sitios (CSRF) y asegurando la integridad de las sesiones de los usuarios.",
            datos: "Almacena un token de seguridad único y aleatorio asociado a la sesión del usuario.",
            caducidad: "Sesión (se elimina al cerrar el navegador)",
        },
        {
            nombre: "Language",
            tipo: "Personalización",
            origen: "Propia",
            proposito:
                "Esta cookie se utiliza para recordar el idioma preferido del usuario en el sitio web, asegurando que el contenido se muestre en el idioma seleccionado en futuras visitas.",
            datos: "Almacena el código del idioma preferido del usuario, como 'es' para español, 'en' para inglés, etc.",
            caducidad: "1 año",
        },
        {
            nombre: "Theme",
            tipo: "Personalización",
            origen: "Propia",
            proposito:
                "Esta cookie se utiliza para recordar la preferencia de tema visual del usuario en el sitio web, como el modo claro u oscuro, asegurando que la interfaz se muestre según su elección en futuras visitas.",
            datos: "Almacena el valor del tema seleccionado, como 'light' para modo claro o 'dark' para modo oscuro.",
            caducidad: "1 año",
        },
        {
            nombre: "Tracking",
            tipo: "Analítica",
            origen: "Propia",
            proposito:
                "Esta cookie se utiliza para rastrear la actividad del usuario en el sitio web con el fin de recopilar datos sobre su comportamiento, mejorar la experiencia de usuario y realizar análisis de tráfico.",
            datos: "Información sobre la navegación del usuario (páginas visitadas, tiempo de permanencia, clics, ubicación aproximada, dispositivo utilizado).",
            caducidad: "1 año",
        },
    ];

    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate("/"); // Navega a la principal y va al footer
    };

    useEffect(() => {
        window.scrollTo(0, 0); // Desplaza la página al inicio
    }, []);

    return (
        <div style={{ padding: "20px", fontFamily: "Montserrat, sans-serif" }}>
            <p className="titulo">POLÍTICA DE COOKIES</p>

            <p className="texto">
                El objetivo de la presente Política es trasladar al usuario de manera
                transparente la existencia y el uso de cookies que realiza {nombre_cliente}
                en su página web, informando sobre su definición, la tipología de cookies
                utilizadas, identificando quién las utiliza, así como las opciones para
                gestionar su consentimiento o su rechazo al empleo de las mismas, el
                periodo de conservación de los datos y aportar información relevante en
                materia de protección de datos.
            </p>

            <p className="subtitulos">Información general</p>
            <br />
            <p className="subtitulos">1. ¿Qué son las cookies?</p>
            <p className="texto">
                Las cookies son ficheros que se descargan en el dispositivo del usuario
                (como un teléfono móvil u ordenador) a través de los sitios web que un
                usuario visita. Las cookies se descargan mientras se navega por Internet y
                su finalidad principal es recabar datos de navegación del usuario para
                mejorar los servicios y el funcionamiento de la página web, elaborar
                información estadística y mostrarle contenido personalizado.
            </p>
            <p className="texto">
                Le informamos que en el transcurso de su navegación por este dominio de{" "}
                {nombre_cliente.split(",")[0]} se utilizan cookies propias técnicas, que
                permiten el acceso a la navegación y a los servicios que se ofrecen en el
                sitio web; cookies propias de personalización que, si lo autoriza,
                recordarán sus preferencias mientras navega por el sitio web; y cookies
                propias gestionadas por terceros que, si lo autoriza, analizarán su
                navegación con fines estadísticos. Los usos concretos que hacemos de estas
                tecnologías se describen a continuación.
            </p>

            <p className="subtitulos">2. ¿Para qué utilizamos las cookies en este sitio web?</p>
            <p className="texto">
                En general, utilizamos las cookies para conocer la actividad de los
                visitantes a nuestra página web, en concreto para obtener información
                relacionada con la fecha y hora de visita, así como preferencias en sus
                hábitos de navegación, analizar sus hábitos de navegación para introducir
                cambios en el sitio web que mejoren su rendimiento o el acceso a productos
                en los que se haya mostrado mayor interés. También se utilizan para
                proporcionar información sobre la navegación de los usuarios a los
                propietarios de otros sitios web y sus colaboradores, con el fin de
                analizar el uso que realizan nuestra página web.
            </p>
            <p className="texto">
                Al navegar por nuestra página web se utilizan cookies que pueden
                clasificarse de la siguiente manera:
            </p>

            <h2 className="texto">Según el plazo de conservación en el dispositivo del usuario:</h2>
            <li className="texto">
                Las <b>cookies de sesión</b> son aquellas cuya persistencia en el
                dispositivo empleado por el usuario se limita al tiempo que el mismo esté
                navegando por el presente sitio web. Están diseñadas para recabar y
                almacenar datos mientras el usuario accede a una página web. Se suelen
                emplear para almacenar información que solo interesa conservar para la
                prestación del servicio solicitado por el usuario en una sola ocasión.
            </li>
            <li className="texto">
                Las <b>cookies persistentes</b> son aquellas que se mantienen en el
                dispositivo del usuario más allá de la sesión de navegación. En
                particular, permiten que los datos sigan almacenados en el terminal y a
                los que se puede acceder y tratar durante un periodo definido por el
                responsable de la cookie, y que puede ir de unos minutos a varios años.
            </li>

            <h2 className="texto">Según la Entidad que las gestione:</h2>
            <li className="texto">
                Las <b>cookies propias</b> son aquellas creadas o gestionadas por el
                responsable de la página web, en este caso, FBMCLM, y que se envían al
                equipo terminal del usuario desde un equipo o dominio gestionado por el
                propio editor y desde el que se presta el servicio solicitado por los
                usuarios. Utilizamos cookies propias persistentes con fines técnicos para
                controlar la visualización del banner informativo sobre cookies.
            </li>
            <li className="texto">
                Las <b>cookies de terceros</b> son aquéllas que se envían al equipo
                terminal del usuario desde un equipo o dominio que no es gestionado por el
                editor, sino por otra entidad que trata los datos obtenidos través de las
                cookies.
            </li>

            <h2 className="texto">
                Según la finalidad para la que se traten los datos obtenidos a través de
                las cookies:
            </h2>
            <li className="texto">
                <b>Cookies técnicas</b> (necesarias): Son aquellas que permiten al usuario
                la navegación a través de una página web, plataforma o aplicación y la
                utilización de las diferentes opciones o servicios que en ella existan.
                Por ejemplo, las utilizamos, principalmente, para el mantenimiento de la
                sesión, el cálculo de tiempo de respuesta, realizar la solicitud de
                inscripción o participación en un evento, utilizar elementos de seguridad
                durante tu navegación y habilitar contenidos dinámicos.
            </li>
            <li className="texto">
                <b>Cookies de personalización</b> (preferencias): Son aquéllas que
                permiten al usuario acceder al servicio con algunas características de
                carácter general predefinidas, en función de una serie de criterios en el
                terminal del usuario (por ejemplo, el idioma, el tipo de navegador a
                través del cual accede al servicio, etc.).
            </li>
            <li className="texto">
                <b>Cookies de análisis o de medición</b> (estadísticas): Son aquellas que
                permiten el seguimiento y análisis del comportamiento de los usuarios de
                los sitios web a los que están vinculadas. La información recogida mediante
                este tipo de cookies se utiliza en la medición de la actividad de los
                sitios web, aplicación o plataforma y para la elaboración de perfiles de
                navegación de los usuarios de dichos sitios, con el fin de introducir
                mejoras en función del análisis de los datos de uso que hacen los usuarios
                del servicio.
            </li>

            <p className="subtitulos">3. ¿Cómo puedo otorgar, denegar o revocar mi consentimiento?</p>
            <p className="texto">
                El empleo de cookies imprescindibles y estrictamente necesarias para el
                correcto funcionamiento del sitio web no se encuentra sujeto a aceptación
                por parte del usuario. Por este motivo, no podrá modificar su valor en el
                Panel de Configuración de Cookies.
            </p>
            <p className="texto">
                La instalación de cualquier otra tipología de cookies empleadas en este
                sitio web se encuentra sujeto a aceptación expresa y previa por parte del
                usuario mediante la aceptación o denegación de las mismas a través del
                panel de configuración mostrado al abrir la página.
            </p>
            <p className="texto">
                Le informamos que, en caso de no seleccionar ninguna opción del panel de
                configuración, equivaldría a un rechazo, de modo que no serán instaladas
                ni empleadas en su dispositivo cookies que no sean indispensables.
            </p>
            <p className="texto">
                Finalmente, le informamos que nosotros no controlamos la persistencia de
                las cookies de terceros, por lo que, si acepta su uso, deberá eliminarlas
                desde las opciones del navegador o desde el sistema ofrecido por el propio
                tercero.
            </p>

            <p className="subtitulos">4. Declaración de Cookies</p>
            <p className="texto">
                La información recabada por las cookies técnicas o indispensables,
                analíticas, de personalización, de publicidad y de publicidad
                comportamental empleadas en esta página web son utilizadas por la Entidad
                en su condición de editor del sitio web. Estamos hablando de cookies
                propias y cookies de terceros. Te facilitamos a continuación, el detalle
                sobre cómo se utilizan estas cookies.
            </p>
            <p className="texto">
                Para una mejor aclaración del contenido de cada tipología de cookies,
                mostramos el listado de cookies utilizado:
            </p>
            <li className="texto">Nombre: identifica el nombre de la cookie.</li>
            <li className="texto">Tipo: identifica el tipo técnico de cookie.</li>
            <li className="texto">
                Proveedor: se especifica el titular de la cookie para poder diferencias
                aquellas que son propia de la Entidad o de terceros.
            </li>
            <li className="texto">Propósito: hace referencia a la finalidad del uso de la cookie.</li>
            <li className="texto">
                Caducidad: se especifica el plazo de conservación de la cookie en el
                dispositivo del usuario.
            </li>

            <table className="cookies-table">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Tipo</th>
                        <th>Origen</th>
                        <th>Propósito</th>
                        <th>Datos</th>
                        <th>Caducidad</th>
                    </tr>
                </thead>
                <tbody>
                    {cookiesData.map((cookie, index) => (
                        <tr key={index}>
                            <td>{cookie.nombre}</td>
                            <td>{cookie.tipo}</td>
                            <td>{cookie.origen}</td>
                            <td>{cookie.proposito}</td>
                            <td>{cookie.datos}</td>
                            <td>{cookie.caducidad}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Botón para volver atrás */}
            <button className="go-back-btn" onClick={handleGoBack}>
                <FiArrowLeft size={20} style={{ marginRight: "8px" }} />
                Volver
            </button>
        </div>
    );
}

export default Cookies;
